import './Project.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExternalLinkAlt, faCodeBranch } from '@fortawesome/free-solid-svg-icons';

const Projects = () => {
  const projects = [
    {
      title: "Grievance Redressal System (CGG)",
      description:
        "An enterprise-level grievance management platform built for public administration, using ASP.NET Core MVC, Dapper ORM, and Oracle DB.",
      technologies: [".NET Core", "Dapper", "Oracle", "JavaScript", "Bootstrap"],
      type: "Enterprise Web Application",
      demo: "https://prajavani.cgg.gov.in/", 
      github: "https://github.com/jathinyattapu",
    },
    {
      title: "Production Planning System",
      description:
        "A full-stack production and inventory management web app using .NET Core and React, optimized for real-time workflow tracking.",
      technologies: [".NET Core", "React", "SQL Server"],
      type: "Full Stack Application",
      demo: "https://example.com",
      github: "https://github.com/jathinyattapu",
    },
    {
      title: "PG Management Software",
      description:
        "MERN stack application for managing paying guest details, rent tracking, and room allocations with JWT-based authentication.",
      technologies: ["MongoDB", "Express", "React", "Node.js"],
      type: "MERN Stack App",
      demo: "https://pgmanagement-iota.vercel.app/",
      github: "https://github.com/jathinyattapu/PG-Management",
    },
  ];

  return (
    <section id="projects" className="projects-section">
      <h2 className="section-title">Projects</h2>
      <div className="projects-grid">
        {projects.map((project, index) => (
          <div key={index} className="project-card">
            <h3>{project.title}</h3>
            <p className="project-type">{project.type}</p>
            <p>{project.description}</p>

            <ul className="tech-list">
              {project.technologies.map((tech, i) => (
                <li key={i}>{tech}</li>
              ))}
            </ul>

            <div className="project-links">
              <a href={project.demo} target="_blank" rel="noopener noreferrer">
                <FontAwesomeIcon icon={faExternalLinkAlt} /> Live Demo
              </a>
              <a href={project.github} target="_blank" rel="noopener noreferrer">
                <FontAwesomeIcon icon={faCodeBranch} /> GitHub
              </a>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Projects;
